import {
    START_UPDATE_APP_INFO,
    FINISH_UPDATE_APP_INFO,
    UPDATE__USER__CONFIG__ENV___APP_INFO,
    UPDATE__USER
} from "./constants";

export const startUpdateAppInfo = (payload) => {
    return {
        type: START_UPDATE_APP_INFO,
        payload
    }
};

export const finishUpdateAppInfo = () => {
    return {
        type: FINISH_UPDATE_APP_INFO
    }
};

export const updateAppInfo = (payload) => {
    return {
        type: UPDATE__USER__CONFIG__ENV___APP_INFO,
        payload
    }
};

export const updateUser = (payload) => {
    return {
        type: UPDATE__USER,
        payload
    }
};
